import { useMutation, useQuery, UseMutationOptions, UseQueryOptions } from '@tanstack/react-query'
import { TUseMutationOptions, TUseQueryOptions, TCustomUseQueryMeta } from 'core/query/type'
import {
  TPostGsipParams,
  TPostGsipResponse,
  postGsip,
  TGetPublicCommonLocalesParams,
  TGetPublicCommonLocalesResponse,
  getPublicCommonLocales,
  TGetMarketTradeAreasParams,
  TGetMarketTradeAreasResponse,
  getMarketTradeAreas,
  TGetPublicGetWebConfigParams,
  TGetPublicGetWebConfigResponse,
  getPublicGetWebConfig,
  TPostMarketTradeAreasParams,
  TPostMarketTradeAreasResponse,
  postMarketTradeAreas,
  TPutMarketTradeAreasParams,
  TPutMarketTradeAreasResponse,
  putMarketTradeAreas,
  TDeleteMarketTradeAreasParams,
  TDeleteMarketTradeAreasResponse,
  deleteMarketTradeAreas,
  TPostPartnerGetGgaConfigParams,
  TPostPartnerGetGgaConfigResponse,
  postPartnerGetGgaConfig,
  TGetPublicKycGetConfigParams,
  TGetPublicKycGetConfigResponse,
  getPublicKycGetConfig,
  TGetPublicLocales5g2et0FRParams,
  TGetPublicLocales5g2et0FRResponse,
  getPublicLocales5g2et0FR,
  TGetPublicLocalesFiats5g2et0FRParams,
  TGetPublicLocalesFiats5g2et0FRResponse,
  getPublicLocalesFiats5g2et0FR,
  TGetPublicServiceGetConfigParams,
  TGetPublicServiceGetConfigResponse,
  getPublicServiceGetConfig,
  TGetV2GetConfigParams,
  TGetV2GetConfigResponse,
  getV2GetConfig,
  TPostV2GetConfigParams,
  TPostV2GetConfigResponse,
  postV2GetConfig,
  TPutV2GetConfigParams,
  TPutV2GetConfigResponse,
  putV2GetConfig,
  TDeleteV2GetConfigParams,
  TDeleteV2GetConfigResponse,
  deleteV2GetConfig,
  TGetV3GetConfigParams,
  TGetV3GetConfigResponse,
  getV3GetConfig,
  TPostV3GetConfigParams,
  TPostV3GetConfigResponse,
  postV3GetConfig,
  TPutV3GetConfigParams,
  TPutV3GetConfigResponse,
  putV3GetConfig,
  TDeleteV3GetConfigParams,
  TDeleteV3GetConfigResponse,
  deleteV3GetConfig,
} from 'core/service/yapi/hk-web/AppConfig/api'
// APP配置接口
// gsip
export const usePostGsipMutation = (
  mutationOptions?: TUseMutationOptions<TPostGsipResponse, TPostGsipParams> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['AppConfig', 'Gsip', 'Post'],
    mutationFn: (params?: TPostGsipParams) => postGsip(params, mutationOptions?.meta?.requestOptions),
  })
}

// getRestrictedConfig
export const useGetPublicCommonLocalesQuery = (
  params?: TGetPublicCommonLocalesParams,
  options?: TUseQueryOptions<TGetPublicCommonLocalesResponse> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useQuery({
    ...options,
    queryKey: ['AppConfig', 'PublicCommonLocales', 'GET', ...Object.values(params || {})],
    queryFn: () => getPublicCommonLocales(params, options?.meta?.requestOptions),
  })
}

// tradeMarkets
export const useGetMarketTradeAreasQuery = (
  params?: TGetMarketTradeAreasParams,
  options?: TUseQueryOptions<TGetMarketTradeAreasResponse> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useQuery({
    ...options,
    queryKey: ['AppConfig', 'MarketTradeAreas', 'GET', ...Object.values(params || {})],
    queryFn: () => getMarketTradeAreas(params, options?.meta?.requestOptions),
  })
}

// 获取WEB配置信息
export const useGetPublicGetWebConfigQuery = (
  params?: TGetPublicGetWebConfigParams,
  options?: TUseQueryOptions<TGetPublicGetWebConfigResponse> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useQuery({
    ...options,
    queryKey: ['AppConfig', 'PublicGetWebConfig', 'GET', ...Object.values(params || {})],
    queryFn: () => getPublicGetWebConfig(params, options?.meta?.requestOptions),
  })
}

// tradeMarkets
export const usePostMarketTradeAreasMutation = (
  mutationOptions?: TUseMutationOptions<TPostMarketTradeAreasResponse, TPostMarketTradeAreasParams> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['AppConfig', 'MarketTradeAreas', 'Post'],
    mutationFn: (params?: TPostMarketTradeAreasParams) =>
      postMarketTradeAreas(params, mutationOptions?.meta?.requestOptions),
  })
}

// tradeMarkets
export const usePutMarketTradeAreasMutation = (
  mutationOptions?: TUseMutationOptions<TPutMarketTradeAreasResponse, TPutMarketTradeAreasParams> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['AppConfig', 'MarketTradeAreas', 'Put'],
    mutationFn: (params?: TPutMarketTradeAreasParams) =>
      putMarketTradeAreas(params, mutationOptions?.meta?.requestOptions),
  })
}

// tradeMarkets
export const useDeleteMarketTradeAreasMutation = (
  mutationOptions?: TUseMutationOptions<TDeleteMarketTradeAreasResponse, TDeleteMarketTradeAreasParams> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['AppConfig', 'MarketTradeAreas', 'Delete'],
    mutationFn: (params?: TDeleteMarketTradeAreasParams) =>
      deleteMarketTradeAreas(params, mutationOptions?.meta?.requestOptions),
  })
}

// 获取Google分析配置
export const usePostPartnerGetGgaConfigMutation = (
  mutationOptions?: TUseMutationOptions<TPostPartnerGetGgaConfigResponse, TPostPartnerGetGgaConfigParams> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['AppConfig', 'PartnerGetGgaConfig', 'Post'],
    mutationFn: (params?: TPostPartnerGetGgaConfigParams) =>
      postPartnerGetGgaConfig(params, mutationOptions?.meta?.requestOptions),
  })
}

// 获取KYC认证配置，version版本号，默认是0，1-20250110版本(AmlBot)
export const useGetPublicKycGetConfigQuery = (
  params?: TGetPublicKycGetConfigParams,
  options?: TUseQueryOptions<TGetPublicKycGetConfigResponse> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useQuery({
    ...options,
    queryKey: ['AppConfig', 'PublicKycGetConfig', 'GET', ...Object.values(params || {})],
    queryFn: () => getPublicKycGetConfig(params, options?.meta?.requestOptions),
  })
}

// getRestrictedConfiglocales
export const useGetPublicLocales5g2et0FRQuery = (
  params?: TGetPublicLocales5g2et0FRParams,
  options?: TUseQueryOptions<TGetPublicLocales5g2et0FRResponse> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useQuery({
    ...options,
    queryKey: ['AppConfig', 'PublicLocales5g2et0FR', 'GET', ...Object.values(params || {})],
    queryFn: () => getPublicLocales5g2et0FR(params, options?.meta?.requestOptions),
  })
}

// 国家或地区与货币映射关系
export const useGetPublicLocalesFiats5g2et0FRQuery = (
  params?: TGetPublicLocalesFiats5g2et0FRParams,
  options?: TUseQueryOptions<TGetPublicLocalesFiats5g2et0FRResponse> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useQuery({
    ...options,
    queryKey: ['AppConfig', 'PublicLocalesFiats5g2et0FR', 'GET', ...Object.values(params || {})],
    queryFn: () => getPublicLocalesFiats5g2et0FR(params, options?.meta?.requestOptions),
  })
}

// 获取客服系统配置
export const useGetPublicServiceGetConfigQuery = (
  params?: TGetPublicServiceGetConfigParams,
  options?: TUseQueryOptions<TGetPublicServiceGetConfigResponse> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useQuery({
    ...options,
    queryKey: ['AppConfig', 'PublicServiceGetConfig', 'GET', ...Object.values(params || {})],
    queryFn: () => getPublicServiceGetConfig(params, options?.meta?.requestOptions),
  })
}

// getConfig
export const useGetV2GetConfigQuery = (
  params?: TGetV2GetConfigParams,
  options?: TUseQueryOptions<TGetV2GetConfigResponse> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useQuery({
    ...options,
    queryKey: ['AppConfig', 'V2GetConfig', 'GET', ...Object.values(params || {})],
    queryFn: () => getV2GetConfig(params, options?.meta?.requestOptions),
  })
}

// getConfig
export const usePostV2GetConfigMutation = (
  mutationOptions?: TUseMutationOptions<TPostV2GetConfigResponse, TPostV2GetConfigParams> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['AppConfig', 'V2GetConfig', 'Post'],
    mutationFn: (params?: TPostV2GetConfigParams) => postV2GetConfig(params, mutationOptions?.meta?.requestOptions),
  })
}

// getConfig
export const usePutV2GetConfigMutation = (
  mutationOptions?: TUseMutationOptions<TPutV2GetConfigResponse, TPutV2GetConfigParams> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['AppConfig', 'V2GetConfig', 'Put'],
    mutationFn: (params?: TPutV2GetConfigParams) => putV2GetConfig(params, mutationOptions?.meta?.requestOptions),
  })
}

// getConfig
export const useDeleteV2GetConfigMutation = (
  mutationOptions?: TUseMutationOptions<TDeleteV2GetConfigResponse, TDeleteV2GetConfigParams> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['AppConfig', 'V2GetConfig', 'Delete'],
    mutationFn: (params?: TDeleteV2GetConfigParams) => deleteV2GetConfig(params, mutationOptions?.meta?.requestOptions),
  })
}

// getV3Config
export const useGetV3GetConfigQuery = (
  params?: TGetV3GetConfigParams,
  options?: TUseQueryOptions<TGetV3GetConfigResponse> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useQuery({
    ...options,
    queryKey: ['AppConfig', 'V3GetConfig', 'GET', ...Object.values(params || {})],
    queryFn: () => getV3GetConfig(params, options?.meta?.requestOptions),
  })
}

// getV3Config
export const usePostV3GetConfigMutation = (
  mutationOptions?: TUseMutationOptions<TPostV3GetConfigResponse, TPostV3GetConfigParams> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['AppConfig', 'V3GetConfig', 'Post'],
    mutationFn: (params?: TPostV3GetConfigParams) => postV3GetConfig(params, mutationOptions?.meta?.requestOptions),
  })
}

// getV3Config
export const usePutV3GetConfigMutation = (
  mutationOptions?: TUseMutationOptions<TPutV3GetConfigResponse, TPutV3GetConfigParams> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['AppConfig', 'V3GetConfig', 'Put'],
    mutationFn: (params?: TPutV3GetConfigParams) => putV3GetConfig(params, mutationOptions?.meta?.requestOptions),
  })
}

// getV3Config
export const useDeleteV3GetConfigMutation = (
  mutationOptions?: TUseMutationOptions<TDeleteV3GetConfigResponse, TDeleteV3GetConfigParams> & {
    meta?: TCustomUseQueryMeta
  }
) => {
  return useMutation({
    ...mutationOptions,
    mutationKey: ['AppConfig', 'V3GetConfig', 'Delete'],
    mutationFn: (params?: TDeleteV3GetConfigParams) => deleteV3GetConfig(params, mutationOptions?.meta?.requestOptions),
  })
}
